import {
  Body,
  Button,
  Group,
  H6,
  Stack,
  useTheme,
  useWindowProperties,
} from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import { ContactEmails, ContactNumbers } from '~/constants/markets';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';
import { StandardPageContainer } from '~/styles/BaseStyledComponents';

export const SvcOnboardingAuthErrorScreen = () => {
  const t = useTranslate();
  const market = useSelector((state: RootState) => state.intl.market);
  const theme = useTheme();
  const { isDesktop } = useWindowProperties();

  const phone = ContactNumbers[market];
  const email = ContactEmails[market];

  return (
    <StandardPageContainer
      $background={theme.fn.themeColor('neutral.12')}
      style={{
        justifyContent: 'center',
      }}
    >
      <Stack
        align="center"
        spacing="sm"
        p="32px"
        w={'600px'}
        h={'694px'}
        maw={'80%'}
        mah={'80%'}
        bg={'Container/Option_2_(White)'}
        justify="space-between"
        style={{ overflow: 'auto' }}
      >
        <img
          src="/illustrations/general/error.png"
          alt=""
          style={{
            width: isDesktop ? '240px' : '160px',
            height: isDesktop ? '240px' : '160px',
          }}
        />
        <H6 color="Text/Headlines_(Brand)">
          {t('SvcOnboardingAuth.GenericErrorTitle')}
        </H6>
        <Body size="lg" color="Text/Secondary" style={{ textAlign: 'center' }}>
          {t('SvcOnboardingAuth.GenericErrorDescription')}
        </Body>
        <Group spacing="md" style={{ width: '100%' }}>
          <a href={`tel:${phone}`} style={{ flex: 1 }}>
            <Button fullWidth size="md" variant="secondary" leftIcon="call">
              {t('SvcOnboardingAuth.CallSupport')}
            </Button>
          </a>
          <a href={`mailto:${email}`} style={{ flex: 1 }}>
            <Button fullWidth size="md" leftIcon="mail">
              {t('SvcOnboardingAuth.EmailSupport')}
            </Button>
          </a>
        </Group>
      </Stack>
    </StandardPageContainer>
  );
};
